import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { ApiCallbacks } from '@utils/api/run-api-get'

import { useDemoShiftControlStore } from '@stores/demo-shift-control'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { runApiGet } from '@utils/api/run-api-get'

interface WaitingBookingsApiPayload {
  page?: number
  per_page?: number
}

type WaitingBookingsApiOptions = ApiCallbacks<AppSelectOption<number>[]>

export const useWaitingBookingsApi = async (
  payload: WaitingBookingsApiPayload = {},
  options?: WaitingBookingsApiOptions,
): Promise<AppSelectOption<number>[] | null> => {
  const demoShiftControlStore = useDemoShiftControlStore()

  const url = useAdminRoutes('admin.demo-slots.waiting-bookings', {
    page: payload.page ?? 1,
    per_page: payload.per_page ?? 20,
  })

  return runApiGet<AppSelectOption<number>[]>(url, {
    setLoading: (loading) => demoShiftControlStore.setLoading(loading),
    handle: (response) => {
      const items: AppSelectOption<number>[] = response?.data?.items || []
      demoShiftControlStore.setWaitingBookings(items)
      return items
    },
    hooks: options,
  })
}
